import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    SearchInventoryTagsInput,
    SearchInventoryTagsResponse,
} from '../../types/inventory';

const searchInventoryTags = async (
    sessionId: string,
    input: SearchInventoryTagsInput,
): Promise<SearchInventoryTagsResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/tags/search`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useSearchInventoryTags = (
    search: string = '',
    limit: number = 20,
    enabled: boolean = true,
) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: [
            '/inventory/tags/search',
            sessionContext?.organizationId ?? '',
            search,
            limit,
        ],
        queryFn: () =>
            searchInventoryTags(sessionContext?.sessionId ?? '', {
                search: search || undefined,
                limit,
            }),
        enabled: !!sessionContext?.sessionId && enabled,
        staleTime: 30_000,
    });
};
